
import {filter, takeUntil} from 'rxjs/operators';
import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ModalFormHostStateService } from '@shared/components/modal-form-host/modal-form-host-state.service';
import { ModalFormHostService } from '@shared/components/model-form-host-ex/modal-form-host-service/modal-form-host.service';
import { BehaviorSubject, ReplaySubject } from 'rxjs';

@Component({
    selector: 'app-components-modal-confirmation-form-host',
    templateUrl: './modal-confirmation-form-host.component.html',
    styleUrls: ['./modal-confirmation-form-host.component.scss']
})
export class ModalConfirmationFormHostComponent implements OnInit, OnDestroy {

    constructor(
        private state: ModalFormHostStateService,
        private modalService: ModalFormHostService
    ) { }

    private destroy$ = new ReplaySubject<boolean>();

    @Input()
    get id(): string { return this.id$.value; }
    set id(value: string) { this.id$.next(value); }
    public id$: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);

    @Input()
    get ids(): string[] { return this.ids$.value; }
    set ids(value: string[]) { this.ids$.next(value); }
    public ids$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>(undefined);

    @Input()
    get model(): any { return this.model$.value; }
    set model(value: any) { this.model$.next(value); }
    public model$: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);

    @Input()
    get isMultiDelete(): boolean { return this.isMultiDelete$.value; }
    set isMultiDelete(value: boolean) { this.isMultiDelete$.next(value); }
    public isMultiDelete$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    @Input()
    get message(): string { return this.message$.value; }
    set message(value: string) { this.message$.next(value); }
    public message$: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);

    @Output()
    public formSubmitted = new EventEmitter<any>();

    @Output()
    public formSubmittedMulti = new EventEmitter<string[]>();

    @ViewChild(NgForm, { static: true })
    set form(value: NgForm) { this.form$.next(value); }
    get form(): NgForm { return this.form$.value; }
    public form$: BehaviorSubject<NgForm> = new BehaviorSubject<NgForm>(undefined);

    @HostListener('window:beforeunload', ['$event'])
    public unloadNotification($event: any) {
        $event.returnValue = true;
    }

    public ngOnInit(): void {
        this.state.form = this.form;
        this.modalService.setForm(this.form);
        this.form$.pipe(
            takeUntil(this.destroy$),
            filter(x => !!x),)
            .subscribe(x => {
                this.state.form = x;
                this.modalService.setForm(this.form);
            });
    }

    public ngOnDestroy(): void {
        this.state.clear();

        this.destroy$.next(true);
        this.destroy$.complete();
    }

    public onSubmit() {
        if (this.isMultiDelete) {
            this.formSubmittedMulti.emit(this.ids);
        } else {
            if (this.model) {
                this.formSubmitted.emit(this.model);
            } else {
                this.formSubmitted.emit(this.id);
            }
        }
    }

}
